import React from 'react';
import AboutUs from "../../views/aboutUs";

const About = () => {

    return (
        <AboutUs />
    )
}
export default About;